import { useState } from "react";
import { Link, useLocation, useNavigate, Outlet, Navigate } from "react-router-dom";
import {
  LayoutDashboard, CalendarCheck, Sparkles, Tag, Star, Palette,
  Phone, Mail, CreditCard, Shield, LogOut, Menu, X,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useApp } from "../context/AppContext";

const NAV = [
  { to: "/admin", label: "لوحة التحكم", icon: LayoutDashboard, end: true },
  { to: "/admin/bookings", label: "الحجوزات", icon: CalendarCheck },
  { to: "/admin/services", label: "الخدمات", icon: Sparkles },
  { to: "/admin/offers", label: "العروض", icon: Tag },
  { to: "/admin/reviews", label: "التقييمات", icon: Star },
  { to: "/admin/design", label: "تصميم الموقع", icon: Palette },
  { to: "/admin/contact", label: "معلومات التواصل", icon: Phone },
  { to: "/admin/email", label: "إعدادات البريد", icon: Mail },
  { to: "/admin/payment", label: "بوابة الدفع", icon: CreditCard },
  { to: "/admin/security", label: "الأمان والحساب", icon: Shield },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  if (!ready) return <div className="min-h-screen grid place-items-center bg-background">جارٍ التحميل...</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;

  const doLogout = () => { logout(); nav("/admin/login"); };
  const active = (item) => item.end ? loc.pathname === item.to : loc.pathname.startsWith(item.to);

  const Sidebar = (
    <aside className="w-64 shrink-0 bg-card border-e border-border flex flex-col h-full">
      <div className="p-5 flex items-center gap-2 border-b border-border">
        <span className="grid place-items-center h-9 w-9 rounded-full cb-gradient text-primary-foreground"><Sparkles className="h-5 w-5" /></span>
        <div>
          <div className="font-display font-bold leading-none">Cloud Beauty</div>
          <div className="text-xs text-muted-foreground">Admin</div>
        </div>
      </div>
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {NAV.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            onClick={() => setOpen(false)}
            data-testid={`admin-nav-${item.to.split("/").pop() || "dashboard"}`}
            className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
              active(item) ? "bg-primary text-primary-foreground" : "text-foreground/70 hover:bg-muted"
            }`}
          >
            <item.icon className="h-5 w-5" /> {item.label}
          </Link>
        ))}
      </nav>
      <button onClick={doLogout} className="m-3 flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-destructive hover:bg-destructive/10" data-testid="admin-logout">
        <LogOut className="h-5 w-5" /> تسجيل الخروج
      </button>
    </aside>
  );

  return (
    <div className="min-h-screen bg-background flex" dir="rtl">
      <div className="hidden lg:block h-screen sticky top-0">{Sidebar}</div>
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div className="h-full">{Sidebar}</div>
          <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="lg:hidden sticky top-0 z-40 cb-glass px-4 py-3 flex items-center justify-between">
          <button onClick={() => setOpen(true)}><Menu className="h-6 w-6" /></button>
          <span className="font-display font-bold">Cloud Beauty Admin</span>
          <button onClick={doLogout}><LogOut className="h-5 w-5 text-destructive" /></button>
        </div>
        <main className="p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
